(() => {
  if (window.woProductDetailsBound) return;
  window.woProductDetailsBound = true;
  const mounted = new WeakMap();
  function mount() {
    document.querySelectorAll('.wo-product-enhanced .wo-product-gallery-accordions').forEach(container => {
      const blocks = Array.from(container.children).filter(block => block.hasAttribute('data-wo-editorial'));
      const previous = mounted.get(container);
      if (previous && previous.buttons.isConnected && blocks.length === previous.blocks.length && blocks.every((block, index) => block === previous.blocks[index] && block.querySelector(':scope > details') === previous.entries[index].detail)) return;
      if (previous) {
        previous.abort.abort();
        previous.buttons.remove();
        mounted.delete(container);
        container.classList.remove('wo-pilot-horizontal-details');
      }
      const entries = blocks.map(block => {
        const detail = block.querySelector(':scope > details');
        const summary = detail && detail.querySelector(':scope > summary');
        const panel = detail && detail.querySelector(':scope > div');
        const title = summary && summary.querySelector('span');
        return { block, detail, panel, title };
      });
      if (!entries.length || entries.some(entry => !entry.detail || !entry.panel || !entry.title)) return;
      const main = container.closest('.wo-product-enhanced');
      const prefix = 'wo-detail-' + main.dataset.template + '-';
      const buttons = document.createElement('div');
      const abort = new AbortController();
      buttons.className = 'wo-pilot-detail-buttons';
      function sync() {
        entries.forEach(entry => entry.button.setAttribute('aria-expanded', String(entry.detail.open)));
      }
      entries.forEach(entry => {
        const button = document.createElement('button');
        const id = prefix + entry.block.dataset.woEditorial;
        button.type = 'button';
        button.className = 'wo-pilot-detail-trigger';
        button.id = id + '-button';
        button.textContent = entry.title.textContent.trim();
        button.setAttribute('aria-controls', id + '-panel');
        entry.panel.id = id + '-panel';
        entry.panel.setAttribute('role', 'region');
        entry.panel.setAttribute('aria-labelledby', button.id);
        entry.button = button;
        button.addEventListener('click', () => {
          const open = !entry.detail.open;
          entries.forEach(item => { item.detail.open = item === entry && open; });
          sync();
        }, { signal: abort.signal });
        entry.detail.addEventListener('toggle', () => {
          if (entry.detail.open) entries.forEach(item => { if (item !== entry) item.detail.open = false; });
          sync();
        }, { signal: abort.signal });
        buttons.append(button);
      });
      const description = entries.find(entry => entry.block.hasAttribute('data-wo-description'));
      if (description) entries.forEach(entry => { entry.detail.open = entry === description; });
      sync();
      container.prepend(buttons);
      container.classList.add('wo-pilot-horizontal-details');
      mounted.set(container, { blocks, entries, buttons, abort });
    });
  }
  new MutationObserver(mount).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', mount);
  mount();
})();
